import React, { ReactElement } from "react";

type Section = {
  id: string;
  label: string;
  icon: React.ComponentType<{ size?: number; className?: string; style?: React.CSSProperties }>;
};

type Props = {
  sections: Section[];
  active: string;
  onClick: (id: string) => void;
};

const PESLayout2Sidebar: React.FC<Props> = ({ sections, active, onClick }) => {

  return (
    <div
      className="aside aside-fixed d-flex flex-column flex-row-auto w-300px pe-5"
    >
      <div className="card h-100">
        <div style={{ position: "sticky", top: "50px" }}>
          <div className="aside-menu flex-column-fluid px-4 py-6 w-100">
            <div
              className="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6"
              data-kt-menu="true"
            >
              {sections.map((section) => {
                const Icon = section.icon
                return (
                  <div className="menu-item" key={section.id}>
                    <span
                      className={`menu-link cursor-pointer text-hover-primary ${active === section.id ? "active text-primary" : ""
                        }`}
                      onClick={() => onClick(section.id)}
                    >
                      <span className="menu-icon">
                        <Icon style={{ color: active === section.id ? "var(--bs-primary)" : "", fontSize: "25px" }} />
                      </span>
                      <span className="menu-title fs-3">{section.label}</span>
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PESLayout2Sidebar;